<template>
  <div class="fixed-price-form">
    <form @submit.prevent="setFixedPrice">
      <b-row v-if="!user && !company && !item && !multiUsers">
        <b-col cols="3" v-if="!tourId">
          <b-form-group>
            <label v-translate>Account for</label>
            <b-form-radio-group stacked v-model="fixedPrice.model_type">
              <b-form-radio value="user"><translate>User</translate></b-form-radio>
              <b-form-radio value="company"><translate>Company</translate></b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group v-show="fixedPrice.model_type === 'company'"><br>
            <company-autocomplete ref="companyAc" @selected="onAccountSearchCompanySelected" :includes="['account']" />
            <span v-if="accountOwner && fixedPrice.model_id">
              <span v-translate="{data: accountOwner}">Company: <strong>%{data}</strong></span><br>
              <span v-translate="{data: fixedPrice.model_id}">Company ID: <strong>%{data}</strong></span> <span class="text-success">✔</span>
            </span>
            <span v-else-if="accountOwner && !fixedPrice.model_id">
              <span v-translate="{data: accountOwner}">Company: <strong>%{data}</strong></span><br>
              <small class="text-danger" v-translate>Warning: No account ID!</small>
            </span>
          </b-form-group>
          <b-form-group v-show="fixedPrice.model_type === 'user'">
            <br>
            <user-autocomplete ref="userAc" @selected="onAccountSearchUserSelected" :restrict-to-roles="['courier']" :includes="['account']" with-picture />
            <span v-if="accountOwner && fixedPrice.model_id">
              <span v-translate="{data: accountOwner}">User: <strong>%{data}</strong></span><br>
              <span v-translate="{data: fixedPrice.model_id}">User ID: <strong>%{data}</strong></span> <span class="text-success">✔</span>
            </span>
            <span v-else-if="accountOwner && !fixedPrice.model_id">
              <span v-translate="{data: accountOwner}">User: <strong>%{data}</strong></span><br>
              <small class="text-danger" v-translate>Warning: No account ID!</small>
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <div class="form-group col-6">
          <label for="change-status" v-translate>From</label>
          <div class="input-group">
            <date-range-picker
              v-if="this.locale.daysOfWeek"
              v-model="updatedDateRange"
              :locale-data="locale"
              :opens="opens"
              class="mb-2 w-100"
              :ranges="ranges"
              @update="updateValues"
              :time-picker="!allDay"
              :time-picker-increment="15"
              ref="dateRange"
              @click="resetupdatedDateRange"
              single-date-picker
            >
              <div slot="input" slot-scope="picker">
                <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                <span style="vertical-align: middle">{{moment(updatedDateRange.startDate).format(!allDay ? 'L LT' : 'L')}}</span>
              </div>
            </date-range-picker>
          </div>
        </div>
        <div class="form-group col-6">
          <label for="change-status" v-translate>Hours</label>
          <div class="input-group">
            <b-form-select v-model="fixedPriceTour.fixed_hours" :disabled="allDay" :required="!allDay">
              <template slot="first">
                <option :value="null" v-translate>How many hours?</option>
              </template>
              <option v-for="index in 18" :key="index" :value="index">
                {{ index }}
              </option>
            </b-form-select>
          </div>
          <div class="input-group" v-if="!fixedPriceTour.tour_id">
            <b-form-checkbox v-model="allDay">
              <translate>All day</translate>
            </b-form-checkbox>
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="form-group col-12">
          <label for="change-status" v-translate>Fixed Amount</label>
          <div class="input-group">
            <b-form-input v-model="fixedPrice.amount"
              type="number"
              step="0.0001"
              required
            ></b-form-input>
            <p v-if="lowerPriceThanBefore" class="text-danger" v-translate>WARNING! the new price is lower than the talked with the courier!</p>
          </div>
          <b-form-text class="text-muted" v-if="multiUsers" v-translate>How much will we pay to each Courier</b-form-text>
          <b-form-text class="text-muted" v-else-if="company" v-translate>How much will the Company pay us</b-form-text>
          <b-form-text class="text-muted" v-else-if="user || fixedPriceTour.tour_id" v-translate>How much will we pay to the Courier</b-form-text>
        </div>
      </b-row>
      <b-row v-if="company && fixedPrice.type === 'time'">
        <div class="form-group col-12">
          <b-form-checkbox v-model="isRestrictedTo">
            <translate>Is the fixed price restricted to one or more couriers?</translate>
          </b-form-checkbox>
        </div>
      </b-row>
      <b-row v-else-if="multiUsers">
        <div class="col-12">
          <h5 v-translate>Pick couriers</h5>
        </div>
      </b-row>
      <b-row v-if="isRestrictedTo || multiUsers">
        <b-col>
          <b-form-group v-show="fixedPrice.restricted_to_model_type === 'company'">
            <company-autocomplete ref="restrictedToCompanyAc" @selected="onRestrictedToCompanySelected" :includes="['account']" />
            <span v-if="restrictedToAccountOwner && fixedPrice.restricted_to_model_id">
              <span v-translate="{data: restrictedToAccountOwner}">Company: <strong>%{data}</strong></span><br>
              <span v-translate="{data: fixedPrice.restricted_to_model_id}">Company ID: <strong>%{data}</strong></span> <span class="text-success">✔</span>
            </span>
            <span v-else-if="restrictedToAccountOwner && !fixedPrice.restricted_to_model_id">
              <span v-translate="{data: restrictedToAccountOwner}">Company: <strong>%{data}</strong></span><br>
              <small class="text-danger" v-translate>Warning: No account ID!</small>
            </span>
          </b-form-group>
          <b-form-group v-show="(!multiUsers && fixedPrice.restricted_to_model_type === 'user') || multiUsers">
            <user-autocomplete ref="restrictedToUserAc" @selected="onRestrictedToUserSelected" :restrict-to-roles="['courier']" :includes="['account']" with-picture />
            <b-row v-for="(user, i) in restrictedTo" class="mt-3" :key="i">
              <b-col>
                <span v-if="user.accountOwner && user.restricted_to_model_id">
                  <span v-translate="{data: user.accountOwner}">User: <strong>%{data}</strong></span><br>
                  <span v-translate="{data: user.restricted_to_model_id}">User ID: <strong>%{data}</strong></span> <span class="text-success">✔</span>
                </span>
                <span v-else-if="user.accountOwner && !user.restricted_to_model_id">
                  <span v-translate="{data: user.accountOwner}">User: <strong>%{data}</strong></span><br>
                  <small class="text-danger" v-translate>Warning: No account ID!</small>
                </span>
              </b-col>
              <b-col>
                <b-button size="sm" variant="danger" @click="restrictedTo.splice(i, 1)"><font-awesome-icon icon="trash-alt" /></b-button>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="fixedPrice.type === 'tour'">
        <div class="form-group col-6">
          <label for="change-status" v-translate>Extra Hour Price</label>
          <div class="input-group">
            <b-form-input v-model="fixedPriceTour.extra_hour_price"
              type="number"
              step="0.0001"
              required
            ></b-form-input>
          </div>
        </div>
        <div class="form-group col-6">
          <label for="change-status" v-translate>Max Extra Hours</label>
          <div class="input-group">
            <b-form-select v-model="fixedPriceTour.max_extra_hours" required>
              <template slot="first">
                <option :value="0">0</option>
              </template>
              <option v-for="index in 24" :key="index" :value="index">
                {{ index }}
              </option>
            </b-form-select>
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="form-group col-sm-12">
          <b-button variant="primary" type="submit" :disabled="!formReady || submitting">
            {{!this.item ? $gettext('Set Fixed Price') : $gettext('Edit Fixed Price')}}
          </b-button>
          <b-button variant="secondary" @click.prevent="emitCancel" v-translate>
            Cancel
          </b-button>
        </div>
      </b-row>
    </form>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'
import UserAutocomplete from '@/components/autocompletes/UserAutocomplete'

export default {
  name: 'FixedPriceForm',
  components: {
    DateRangePicker,
    CompanyAutocomplete,
    UserAutocomplete
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    tourId: {
      type: String,
      default: null
    },
    user: {
      type: Object,
      default: null
    },
    company: {
      type: Object,
      default: null
    },
    multiUsers: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fixedPrice: {
        type: null,
        model_type: 'user',
        model_id: null,
        from_date: null,
        to_date: null,
        amount: null
      },
      fixedPriceTour: {
        tour_id: null,
        fixed_hours: null,
        extra_hour_price: null,
        max_extra_hours: 0
      },
      accountOwner: null,
      companyAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('Company Name, Business Name or TIN'),
        inputClass: 'form-control'
      },
      searchCompanyQuery: '',
      userAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('User Name or Email'),
        inputClass: 'form-control'
      },
      searchUserQuery: '',
      minCharacter: 2,
      updatedDateRange: { // used for v-model prop
        startDate: this.moment().seconds(0).format('YYYY-MM-DD HH:mm:ss'),
        endDate: null
      },
      opens: 'left', //  which way the picker opens, default "center", can be "left"/"right"
      locale: {
        direction: 'ltr', //  direction of text
        format: 'YYYY-MM-DD HH:mm', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 1,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      },
      ranges: false,
      updatedDateRangeActive: 0,
      submitting: false,
      isRestrictedTo: false,
      restrictedToAccountOwner: null,
      allDay: false,
      restrictedTo: []
    }
  },
  computed: {
    formReady() {
      if (this.tourId) {
        return this.fixedPrice.type &&
          this.fixedPrice.model_type &&
          this.fixedPrice.model_id &&
          this.fixedPrice.from_date &&
          this.fixedPrice.to_date &&
          this.fixedPrice.amount &&
          this.fixedPriceTour.tour_id &&
          this.fixedPriceTour.fixed_hours &&
          this.fixedPriceTour.extra_hour_price
      } else if (this.multiUsers) {
        return this.fixedPrice.type &&
          this.fixedPrice.model_type &&
          this.restrictedTo.length > 0 &&
          this.fixedPrice.from_date &&
          this.fixedPrice.to_date &&
          this.fixedPrice.amount
      } else {
        return this.fixedPrice.type &&
          this.fixedPrice.model_type &&
          this.fixedPrice.model_id &&
          this.fixedPrice.from_date &&
          this.fixedPrice.to_date &&
          this.fixedPrice.amount
      }
    },
    lowerPriceThanBefore() {
      return this.item && (parseFloat(this.item.amount) > parseFloat(this.fixedPrice.amount))
    }
  },
  watch: {
    updatedDateRangeActive: {
      handler (val) {
        if (val !== 0) {
          if (!this.allDay) {
            this.fixedPrice.from_date = this.moment.utc(this.updatedDateRange.startDate).seconds(0).format('YYYY-MM-DD HH:mm:ss')
          } else {
            this.fixedPrice.from_date = this.moment(this.updatedDateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
            this.$nextTick(() => {
              this.fixedPrice.to_date = this.moment(this.updatedDateRange.startDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
              this.fixedPriceTour.fixed_hours = 23.99
            })
          }
        } else {
          this.fixedPrice.from_date = null
        }
      },
      deep: true
    },
    allDay(val) {
      if (val) {
        this.fixedPrice.from_date = this.moment(this.updatedDateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
        this.$nextTick(() => {
          this.fixedPrice.to_date = this.moment(this.updatedDateRange.startDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
          this.fixedPriceTour.fixed_hours = 23.999
        })
      } else {
        this.fixedPrice.from_date = this.moment(this.updatedDateRange.startDate).seconds(0).utc().format('YYYY-MM-DD HH:mm:ss')
        this.fixedPrice.to_date = null
      }
    },
    'fixedPriceTour.fixed_hours': {
      handler (val) {
        if (val) {
          if (val < 19) {
            this.fixedPrice.to_date = this.moment(this.updatedDateRange.startDate).seconds(0).add(val, 'hours').utc().format('YYYY-MM-DD HH:mm:ss')
          }
        } else {
          this.fixedPrice.to_date = null
        }
      },
      deep: true
    },
    'fixedPrice.model_type': {
      handler (val) {
        if (!this.user && !this.company && !this.tourId) {
          this.accountOwner = null
          this.fixedPrice.model_id = null
        }
      },
      deep: true
    },
    'fixedPrice.restricted_to_model_type': {
      handler (val, oldVal) {
        if (oldVal && val !== oldVal) {
          this.restrictedToAccountOwner = null
          this.fixedPrice.restricted_to_model_id = null
        }
      },
      deep: true
    },
    'fixedPrice.from_date': {
      handler (val) {
        if (this.fixedPriceTour.fixed_hours) {
          this.fixedPrice.to_date = this.moment(this.updatedDateRange.startDate).seconds(0).add(this.fixedPriceTour.fixed_hours, 'hours').utc().format('YYYY-MM-DD HH:mm:ss')
        }
      },
      deep: true
    },
    isRestrictedTo(val) {
      if (val) {
        this.fixedPrice.restricted_to_model_type = 'user'
      } else {
        this.fixedPrice.restricted_to_model_type = null
      }
    }
  },
  created() {
    if (this.item) {
      this.$http.get(this.$appConfig.api.baseUrl + 'fixed-amount-price-schedules/' + this.item.id, {params: {includes: ['fixed_tour', 'owner', 'restricted_to']}})
        .then(response => {
          this.fixedPrice = response.body
          if (this.fixedPrice.restricted_to_model_id) {
            this.fixedPrice.restricted_to_model_type = this.fixedPrice.restricted_to_model_type === 'Api\\Users\\Models\\User' ? 'user' : 'company'
            this.restrictedToAccountOwner = this.fixedPrice.restricted_to.name
            if (this.fixedPrice && this.fixedPrice.restricted_to_model_type.toLowerCase().indexOf('user') !== -1) {
              this.restrictedTo.push({
                accountOwner: this.fixedPrice.restricted_to.name,
                restricted_to_model_id: this.fixedPrice.restricted_to.id
              })
            }
            this.isRestrictedTo = true
          }
          if (response.body.fixed_tour) {
            this.fixedPriceTour = response.body.fixed_tour
          } else {
            this.fixedPriceTour.fixed_hours = this.moment(response.body.to_date).diff(this.moment(response.body.from_date), 'hours', true)
            if (this.fixedPriceTour.fixed_hours > 18) {
              this.fixedPriceTour.fixed_hours = null
              this.allDay = true
            }
          }
          this.updatedDateRange.startDate = response.body.from_date
        })
    } else if (this.multiUsers) {
      this.fixedPrice.model_type = 'user'
    }
  },
  mounted() {
    const now = this.moment()
    const remainder = 15 - (now.minute() % 15)
    this.updatedDateRange = {
      startDate: this.moment(now).add(remainder, 'minutes').seconds(0).format('YYYY-MM-DD HH:mm:ss'),
      endDate: null
    }
    this.fixedPrice.from_date = this.moment(this.updatedDateRange.startDate).seconds(0).utc().format('YYYY-MM-DD HH:mm:ss')

    if (this.tourId) {
      this.fixedPrice.type = 'tour'
      this.fixedPrice.model_type = 'user'
      this.fixedPriceTour.tour_id = this.tourId
    } else {
      this.fixedPrice.type = 'time'
    }

    if (this.user) {
      this.fixedPrice.model_type = 'user'
      this.fixedPrice.model_id = this.user.id
      this.accountOwner = this.user.name
    }
    if (this.company) {
      this.fixedPrice.model_type = 'company'
      this.fixedPrice.model_id = this.company.id
      this.accountOwner = this.company.name
    }
  },
  methods: {
    resetupdatedDateRange() {
      if (this.updatedDateRangeActive === 0) {
        this.updatedDateRange = {
          startDate: this.moment(),
          endDate: this.moment()
        }
        this.updatedDateRangeActive = 0
      }
    },
    updateValues(obj) {
      this.updatedDateRangeActive++
      this.$refs.dateRange.$el.childNodes[0].className = this.$refs.dateRange.$el.childNodes[0].className.replace(' is-invalid', '')
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    onAccountSearchCompanySelected(item) {
      this.accountOwner = item.name
      if (item.id) {
        this.fixedPrice.model_id = item.id
      } else {
        this.accountingNote.account_id = null
      }
    },
    onRestrictedToCompanySelected(item) {
      this.restrictedToAccountOwner = item.name
      if (item.id) {
        this.fixedPrice.restricted_to_model_id = item.id
      } else {
        this.fixedPrice.restricted_to_model_id = null
      }
    },
    onAccountSearchUserSelected(item) {
      this.accountOwner = item.name
      if (item.id) {
        this.fixedPrice.model_id = item.id
      } else {
        this.accountingNote.account_id = null
      }
    },
    onRestrictedToUserSelected(item) {
      let user = {
        accountOwner: item.name
      }
      if (item.id) {
        user.restricted_to_model_id = item.id
      } else {
        user.restricted_to_model_id = null
      }
      if (!this.item) {
        this.restrictedTo.push(user)
      } else {
        this.restrictedTo = [user]
      }
    },
    setFixedPrice() {
      this.submitting = true
      let payload = this.fixedPrice
      if (this.tourId || this.fixedPriceTour.id) {
        payload.fixed_tour = this.fixedPriceTour
      } else {
        // payload.to_date = this.moment(this.updatedDateRange.startDate).seconds(0).add(this.fixedPriceTour.fixed_hours, 'hours').utc().format('YYYY-MM-DD HH:mm:ss')
        delete payload.fixed_tour
      }
      delete payload.owner
      delete payload.restricted_to

      if (payload.restricted_to_model_type === 'user' && this.restrictedTo.length > 0) {
        for (const user of this.restrictedTo) {
          payload.restricted_to_model_id = user.restricted_to_model_id
          this.doSetFixedPrice(payload)
        }
      } else if (payload.model_type === 'user' && this.restrictedTo.length > 0) {
        for (const user of this.restrictedTo) {
          payload.model_id = user.restricted_to_model_id
          this.doSetFixedPrice(payload)
        }
      } else if (payload.restricted_to_model_type === 'user' && this.restrictedTo.length === 0) {
        payload.restricted_to_model_id = null
        payload.restricted_to_model_type = null
        this.doSetFixedPrice(payload)
      } else {
        this.doSetFixedPrice(payload)
      }
    },
    async doSetFixedPrice(payload) {
      if (!this.item) {
        await this.$http.post(this.$appConfig.api.baseUrl + 'fixed-amount-price-schedules', payload)
          .then(response => {
            this.emitSuccess()
          }, error => {
            console.log(error)
            this.submitting = false
          })
      } else {
        await this.$http.patch(this.$appConfig.api.baseUrl + 'fixed-amount-price-schedules/' + this.item.id, payload)
          .then(response => {
            this.emitSuccess()
          }, error => {
            console.log(error)
            this.submitting = false
          })
      }
    },
    emitSuccess() {
      this.submitting = false
      this.$emit('success')
    },
    emitCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
